// Exposures
// TODO - Documentar
import * as con from "../../GlobalConstants"



// Style
import "../ComponentsGlobalStyle.css"
import { TransactionTable } from '../transactionTable/TransactionTable'
import { ForwardCoveragesHook, useTransactionAnnotations, useTransactionFilters } from '../hooks/TransactionsHooks'
import TransactionTableVisualizer from './TransactionTableVisualizer'
import { allForwardCoverageColumns, selectedForwardCoverageColumns } from '../../utils/transactionFunctions'
import { useDispatch } from "react-redux"
import { addTransaction, deleteTransaction, updateTransaction } from "../../store/slices/transactionsSlice"

function TableCoveragesFwd() {

  // Transaction
  const trans = ForwardCoveragesHook()
    
  const dispatch = useDispatch()
  const { filterFun, searchFun } = useTransactionFilters()
  const getAnnotations = useTransactionAnnotations(con.COVERAGES_FWD)

  // Columns
  const columns = selectedForwardCoverageColumns.map(col => allForwardCoverageColumns[col[con.ID]])

  return (
        <TransactionTableVisualizer transactionType={con.COVERAGES_FWD}>           
                    <TransactionTable transactionType={con.COVERAGES_FWD}
                                      columnArray={columns} 
                                      dataDictionary={trans} 
                                      setRow={(id, vals) =>
                                        dispatch(updateTransaction({
                                          transactionType: con.COVERAGES_FWD,
                                          id,
                                          values: vals
                                        }))
                                      }
                                      addRow={(vals) =>
                                        dispatch(addTransaction({
                                          transactionType: con.COVERAGES_FWD,
                                          values: vals
                                        }))
                                      }
                                      deleteRow={(id) =>
                                        dispatch(deleteTransaction({
                                          transactionType: con.COVERAGES_FWD,
                                          id
                                        }))
                                      }
                                      getAnnotations={getAnnotations}
                                      filterFunction={filterFun}
                                      searchFunction={searchFun}/>
        </TransactionTableVisualizer>        
  )
}

export default TableCoveragesFwd